export default __webpack_public_path__ + "static/media/campana.0cff2f5d.jpeg";